import { Component, OnInit, Input } from '@angular/core';
import { FlowManagementService } from '../services/flow-management.service';
import { WindowRef } from '@progress/kendo-angular-dialog';
import { Flow } from '../obj/Flow';
import { of, Observable } from 'rxjs';
import { TreeItem } from '@progress/kendo-angular-treeview';
import { catchError, map } from 'rxjs/operators';

@Component({
    selector: 'app-flow-rename',
    templateUrl: './flow-rename.component.html',
    styleUrls: ['./flow-rename.component.css'],
    standalone: false
})
export class FlowRenameComponent implements OnInit {

  constructor(
    private flowManagementService: FlowManagementService,
    public windowRef: WindowRef
  ) {

  }

  @Input() flow: Flow;
  data: any;
  flowData: any;
  oldName: string = '';
  newName: string = '';
  error: string = null;

  ngOnInit() {
    this.flowManagementService.getFlow(this.flow.environment, this.flow.flowName).toPromise().then(flow => {
      this.flowData = flow;
      this.fetchChildren(flow.properties.definition).subscribe(nodes => {
        this.data = nodes;
      });
      //this.flow.definition = flow.properties.definition;
    })
  }

  public onSaveClick(): void {
    //console.log("on click");
    // this.flowManagementService.validateFlow(this.flow.environment, this.flow.flowName, body).map((response) => { return response.json(); }).toPromise().then(()=>{
    // this.flowData.tags = {
    //     "kunai-tags": "kunai-customized"
    // };

    this.flowManagementService.updateFlow(this.flow.environment, this.flow.flowName, this.flowData).toPromise().then((response) => {

      if (response == null) {
        // error
        return;
      }
      //alert('done!');
      this.windowRef.close();
    }, (error) => {

      this.error = error;

//      alert("there is an error updating this Flow, this operation can't continue." + error);
    });
    //this.windowRef.close();

    // });
  }

  public fetchChildren(node: any): Observable<any[]> {
    //return the parent node's items collection as children
    var children = Object.keys(node.actions).map(key => Object.assign({}, node.actions[key], { 'text': key }));

    // children.sort((a, b) => {

    //   var aKeys = Object.keys(a.runAfter);
    //   var bKeys = Object.keys(b.runAfter);
    //   if (aKeys.length == 0) {
    //     return -1;
    //   }
    //   if (bKeys.length == 0) {
    //     return 1;
    //   }
    //   if (aKeys[0] == b.text) {
    //     return -1;
    //   }
    //   if (bKeys[0] == a.text) {
    //     return 1;
    //   }
    //   return 1;
    // });

    var results = [];
    var current: string = null;

    while(children.length > 0) {

      var child = children.find( c => {
        var cKeys = Object.keys(c.runAfter);
        return (cKeys.length == 0 && current == null) || (cKeys.length > 0 && cKeys[0] == current);
      });

      if (child) {
        results.push(child);
        children = children.filter(c => c != child);
        current = child.text;
      }
      else {
        // error?
        break;
      }
    }

    return of(results);
  }

  public hasChildren(node: any): boolean {
    //check if the parent node has children
    return node.actions && Object.keys(node.actions).length > 0;
  }

  public selectAction(node: TreeItem) {
    var action = node.dataItem;

    this.oldName = action.text;
    this.newName = action.text;
  }

  public rename() {

    // fix name
    var name = this.newName.replace(/\s/gi, '_').replace(/[<>%&\\?]/gi, '');
    this.newName = name;

    var definition = JSON.stringify(this.flowData.properties.definition);

    // the backslash \ (invalid)
    // , the caret ^, the dollar sign $, the period or dot ., 
    // the vertical bar or pipe symbol |, 
    // the question mark ?, (invalid)
    // the asterisk or star *, the plus sign +, 
    // the opening parenthesis (, the closing parenthesis ), the opening square bracket [, and the opening curly brace {,

    var oldName = this.oldName.replace(/[,^$.|*+\(\)\[\{\]]/gi, '\\$&');

    // replace it in definition
    definition = definition.replace(new RegExp(`"${oldName}":`, 'g'), `"${this.newName}":`);

    definition = definition.replace(new RegExp(`body\\('${oldName}'\\)`, 'g'), `body('${this.newName}')`);
    definition = definition.replace(new RegExp(`outputs\\('${oldName}'\\)`, 'g'), `outputs('${this.newName}')`);

    
    //this.flow.definition = JSON.parse(definition);
    this.flowData.properties.definition = JSON.parse(definition);

    // reload tree
    this.fetchChildren(this.flowData.properties.definition).subscribe(nodes => {
      this.data = nodes;
    });

  }

}
